'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import EmpCard from './empCard';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';

class InfoBody extends React.Component {
    constructor(props) {
        super(props);
        this.onUserChange = this.onUserChange.bind(this);
        this.state={
            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,
        }
    }
    componentDidMount(){
        userStore.listen(this.onUserChange);
    }
    componentWillUnmount(){
        userStore.unlisten(this.onUserChange);
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    render() {
        let employeeList;
        let staffs;
        if (this.props.staffs) {
            staffs = this.props.staffs.filter((staff)=>{
                return(
                    genFunction.hasPermission(this.state.permission, 2) ||
                    genFunction.isSubordinate(this.state.subordinate, staff.staffId) ||
                    genFunction.isUser(this.state.userId, staff.staffId)
                );
            });
            employeeList = staffs.map((staff, index) => {
                return (<EmpCard staff={staff} key={index} history={this.props.history} />)
            });
        }
        return (
            <div className="atd-bd-wp">
                <div className="atd-em-lt">
                    {employeeList}
                </div>
            </div>
        );
    }
}
export default InfoBody;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/infoBody.js